/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * JCS
 */
export type JCSEnum = (typeof JCSEnum)[keyof typeof JCSEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JCSEnum = {
  NUMBER_0: '0',
  '1-2': '1-2',
  '1-1': '1-1',
  '1-3': '1-3',
  '2-10': '2-10',
  '2-20': '2-20',
  '2-30': '2-30',
  '3-100': '3-100',
  '3-200': '3-200',
  '3-300': '3-300',
  OTHER: 'OTHER',
} as const;
